import React, { useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "assets/images/logo.png";
import { auth } from "services/firebase";
import { useSelector, useDispatch } from "react-redux";
import Cart from "components/cart/Cart";
import CartDropdown from "components/cart/cartDropdown/CartDropdown";
import { selectCurrentUser } from "features/user/userSlice";
import { selectCartHidden } from "features/cart/cartSlice";
import { useOutsideClick, useWindowDimensions } from "custom/hooks";

export default function Header() {
  // const currentUser = useSelector((state) => state.user.currentUser);
  const currentUser = useSelector(selectCurrentUser);
  // const hideCart = useSelector((state) => state.cart.hidden);
  const hideCart = useSelector(selectCartHidden);

  const [open, setOpen] = useState(false);
  const handleMenuToggle = () => {
    setOpen(!open);
  };
  const handleMenuClose = () => {
    setOpen(false);
  };

  const ref = useRef(null);
  useOutsideClick(ref, () => {
    handleMenuClose();
  });

  const logOut = () => {
    auth.signOut();
    handleMenuClose();
  };

  const activeStyle = {
    borderWidth: 1,
    borderColor: "black",
    padding: 8,
    borderRadius: "12px",
  };

  const { width } = useWindowDimensions();
  const breakpoint = 900;

  const isResponsive = width <= breakpoint;

  return (
    <div
      className="Header flex justify-between items-center mb-8 2xs:px-3 2xs:py-5 xl:px-20 xl:py-5 sticky top-0 bg-white z-50 backdrop-blur-2xl"
      style={{
        background: "rgba(255, 255, 255, 0.8)",
      }}
    >
      <Link className="Header__logo" to="/">
        <img src={logo} alt="logo" width="60" height="60" />
      </Link>
      <div
        className={`Header__action flex justify-${
          isResponsive ? "end" : "between"
        } items-center w-1/4 2xs:w-3/5 xs:w-1/4`}
      >
        {isResponsive ? (
          <div className="dropdown" ref={ref}>
            <label
              tabIndex={0}
              className="btn btn-ghost btn-circle"
              onClick={handleMenuToggle}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </label>
            {open && (
              <ul
                tabIndex={0}
                className="menu menu-compact dropdown-content mt-3 bg-white p-2 shadow-lg rounded-box absolute right-0 flex flex-col items-center gap-3"
              >
                <NavLink
                  to="/"
                  onClick={handleMenuClose}
                  style={({ isActive }) => (isActive ? activeStyle : null)}
                >
                  HOME
                </NavLink>
                <NavLink
                  to="/shop"
                  onClick={handleMenuClose}
                  style={({ isActive }) => (isActive ? activeStyle : null)}
                >
                  SHOP
                </NavLink>
                {currentUser?.photoURL ? (
                  <div onClick={logOut} className="hover:cursor-pointer">
                    <img
                      className="rounded-full"
                      src={currentUser.photoURL}
                      alt="avatar"
                      width="40"
                      height="40"
                    />
                  </div>
                ) : (
                  <NavLink to="/signin" onClick={handleMenuClose}>
                    SIGN IN
                  </NavLink>
                )}
                <Cart onCloseMenu={handleMenuClose} />
              </ul>
            )}
          </div>
        ) : (
          <>
            <NavLink
              to="/"
              onClick={handleMenuClose}
              style={({ isActive }) => (isActive ? activeStyle : null)}
            >
              HOME
            </NavLink>
            <NavLink
              to="/shop"
              onClick={handleMenuClose}
              style={({ isActive }) => (isActive ? activeStyle : null)}
            >
              SHOP
            </NavLink>
            {currentUser?.photoURL ? (
              <div onClick={logOut} className="hover:cursor-pointer">
                <img
                  className="rounded-full"
                  src={currentUser.photoURL}
                  alt="avatar"
                  width="40"
                  height="40"
                />
              </div>
            ) : (
              <NavLink to="/signin" onClick={handleMenuClose}>
                SIGN IN
              </NavLink>
            )}
            <Cart onCloseMenu={handleMenuClose} />
          </>
        )}
      </div>
      {!hideCart && <CartDropdown />}
    </div>
  );
}
